import { PROBLEM_CODE } from 'apisauce';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import LangEnum from '../../../../../lang/LangEnum';
import snackbarStore from '../../../../../stores/Snackbar.store';
import { useTranslation } from '../../../../translation/TranslationContext';

interface UseCatalogLoadErrorParams {
  isError: boolean;
  error: unknown;
  isRedirectEnabled: boolean;
  redirectPath: string;
}

const useCatalogLoadError = ({
  isError,
  error,
  isRedirectEnabled,
  redirectPath,
}: UseCatalogLoadErrorParams): void => {
  const { translate } = useTranslation();
  const history = useHistory();
  const { problem } = (error ?? {}) as { problem?: PROBLEM_CODE };

  useEffect(() => {
    if (!isError) {
      return;
    }

    snackbarStore.handleMessage({
      type: 'error',
      message: translate(LangEnum.CATALOG_PRODUCTS_V2_LIST_ERROR),
    });

    if (isRedirectEnabled && problem !== 'TIMEOUT_ERROR') {
      history.replace(redirectPath);
    }
  }, [isError, problem, isRedirectEnabled, redirectPath, history, translate]);
};

export default useCatalogLoadError;
